module.exports = __webpack_public_path__ + "static/media/ameg.63950e51.png";